/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Privacy_TitleInputs */

const fr_legal_privacy_title = /** @type {(inputs: Legal_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confidentialité (RGPD)`)
};

const en_legal_privacy_title = /** @type {(inputs: Legal_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy (GDPR)`)
};

/**
* | output |
* | --- |
* | "Privacy (GDPR)" |
*
* @param {Legal_Privacy_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_privacy_title = /** @type {((inputs?: Legal_Privacy_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Privacy_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_privacy_title(inputs)
	return en_legal_privacy_title(inputs)
});